var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editable-cell"},[_vm._v(" "+_vm._s(_vm.data.customer.firstname)+" "+_vm._s(_vm.data.customer.lastname)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }